import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'I dag',
    [filter_yesterday]: 'I går',
    [filter_this_week]: 'Denne uge',
    [filter_last_week]: 'Sidste uge',
    [filter_this_month]: 'Denne måned',
    [filter_last_month]: 'Sidste måned',
    [filter_last_30_days]: 'Seneste 30 dage',
    [filter_all]: 'Alle',
  },
};
